<div *ngIf="loading.isLoading()" class="overlay" role="status" aria-label="Loading"><span class="spinner"></span></div>
